import React from 'react';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import Subscribe from './Subscribe'; // your Subscribe component
import { updateUserSubscriptionProfile } from './SubscribePage.duck';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { injectIntl } from 'react-intl';

//const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || '');

const SubscribePageComponent = ({ location, currentUser, onUpdateUserSubscriptionProfile }) => {
  return (
    // <Elements stripe={stripePromise}>
      <Subscribe location={location} currentUser={currentUser}
        onUpdateUserSubscriptionProfile={onUpdateUserSubscriptionProfile} />
    // </Elements>
  );
};


const mapStateToProps = state => {
  return {
  };
};

const mapDispatchToProps = dispatch => ({
  onUpdateUserSubscriptionProfile: actionPayload => dispatch(updateUserSubscriptionProfile(actionPayload)),
});

const SubscribePage = compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  injectIntl
)(SubscribePageComponent);

export default SubscribePage;

